<template>
  <div v-if="form">
    <b-container fluid>
      <b-row>
        <b-col>
          <h2 class="mb-4">Tarifa da Maquininha</h2>
          <h3 class="mb-3">Evento: {{ form.event.name }}</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-alert class="mt-3" v-model="f.show" :variant="f.variant" dismissible>
            {{ f.msg }}
          </b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mb-2" cols="4">
          <b-form-group id="input-group-3" label="Tarifas pré-configuradas:" label-for="select-layout-rate">
            <b-form-select id="select-layout-rate" v-model="rate_layout" :options="rate_layouts" @change="applyRateLayout"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mb-3">
          <p>Os valores <strong>Tarifa fixa Easytick</strong> e <strong>Porcentagem Easytick</strong> serão os valores que serão considerados nos cálculos das tarifas durante as vendas nas Maquininhas.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12" lg="12" xl="12">
          <b-table responsive="md" striped hover :items="form.payment_methods" :fields="fields" primary-key="method">

            <!-- Coluna: percentage_rate -->
            <template v-slot:cell(percentage_rate_fmted)="data">
              <b-input-group append="%">
                <money required class="form-control text-right" v-model="form.payment_methods[data.index].percentage_rate" v-bind="money"></money>
              </b-input-group>
            </template>

            <!-- Coluna: percentage_rate_acquirer -->
            <template v-slot:cell(percentage_rate_acquirer_fmted)="data">
              <b-input-group append="%">
                <money required class="form-control text-right" v-model="form.payment_methods[data.index].percentage_rate_acquirer" v-bind="money"></money>
              </b-input-group>
            </template>

            <!-- Coluna: fixed_rate -->
            <template v-slot:cell(fixed_rate_fmted)="data">
              <b-input-group prepend="R$">
                <money required class="form-control" v-model="form.payment_methods[data.index].fixed_rate" v-bind="money"></money>
              </b-input-group>
            </template>

            <!-- Coluna: fixed_rate_acquirer -->
            <template v-slot:cell(fixed_rate_acquirer_fmted)="data">
              <b-input-group prepend="R$">
                <money required class="form-control" v-model="form.payment_methods[data.index].fixed_rate_acquirer" v-bind="money"></money>
              </b-input-group>
            </template>

            <!-- Coluna: profit -->
            <template v-slot:cell(profit)="data">
              <span>{{ calculateProfit[data.index].fixedProfit | currency }} + {{ calculateProfit[data.index].percentageProfit | percentage }}</span>
            </template>

            <!-- Coluna: enabled -->
            <template v-slot:cell(enabled_fmted)="data">
              <div>
                <toggle-button
                  :value="form.payment_methods[data.index].enabled"
                  :sync="true" :width="45" :height="25"
                  :color="{checked: '#337ab7', unchecked: '#cccccc'}"
                  @change="toggleEnabled(data.index)"
                />
              </div>
            </template>

          </b-table>

        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12" lg="12" xl="12">
          <b-button @click="save()" :disabled="disableSaveBtn" variant="success" class="mb-3">
            <icon name="save" scale="1" class="mr-2"></icon> Salvar tarifas
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ToggleButton from 'vue-js-toggle-button/src/Button'
import {Money} from 'v-money'

export default {
  name: 'AdminEventRate',
  components: {
    Money,
    ToggleButton
  },
  data () {
    return {
      f: {
        variant: 'danger',
        msg: '',
        show: false
      },
      fields: [
        { key: 'label', label: 'Forma de Pagamento', class: ['align-middle', 'text-nowrap'] },
        { key: 'fixed_rate_fmted', label: 'Tarifa fixa Easytick', class: ['align-middle', 'text-nowrap', 'text-center', 'bg-easy'], tdclass: ['bg-easy'] },
        { key: 'fixed_rate_acquirer_fmted', label: 'Tarifa fixa Stone', class: ['align-middle', 'text-nowrap', 'text-center', 'bg-stone'], tdclass: ['bg-stone'] },
        { key: 'percentage_rate_fmted', label: 'Porcentagem Easytick', class: ['align-middle', 'text-nowrap', 'text-center', 'bg-easy'], tdClass: ['bg-easy'] },
        { key: 'percentage_rate_acquirer_fmted', label: 'Porcentagem Stone', class: ['align-middle', 'text-nowrap', 'text-center', 'bg-stone'], tdclass: ['bg-stone'] },
        { key: 'profit', label: 'Lucro aprox. Easytick', class: ['align-middle', 'text-nowrap', 'text-center'] },
        { key: 'enabled_fmted', label: 'Habilitado', class: ['text-center', 'align-middle'] }
      ],
      form: '',
      form_initial_state: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2
      },
      rate_layout: '',
      rate_layouts: [
        { value: 'stone+0', text: 'Tarifa Stone + 0% de lucro' },
        { value: 'stone+10', text: 'Tarifa Stone + 10% de lucro' },
        { value: 'stone+20', text: 'Tarifa Stone + 20% de lucro' },
        { value: 'stone+30', text: 'Tarifa Stone + 30% de lucro' },
        { value: 'stone+40', text: 'Tarifa Stone + 40% de lucro' },
        { value: 'stone+50', text: 'Tarifa Stone + 50% de lucro' },
        { value: 'stone+60', text: 'Tarifa Stone + 60% de lucro' },
        { value: 'stone+70', text: 'Tarifa Stone + 70% de lucro' },
        { value: 'stone+80', text: 'Tarifa Stone + 80% de lucro' },
        { value: 'stone+90', text: 'Tarifa Stone + 90% de lucro' },
        { value: 'stone+100', text: 'Tarifa Stone + 100% de lucro' },
        { value: 'stone+110', text: 'Tarifa Stone + 110% de lucro' },
        { value: 'stone+120', text: 'Tarifa Stone + 120% de lucro' },
        { value: 'stone+130', text: 'Tarifa Stone + 130% de lucro' },
        { value: 'stone+140', text: 'Tarifa Stone + 140% de lucro' },
        { value: 'stone+150', text: 'Tarifa Stone + 150% de lucro' },
        { value: 'stone+160', text: 'Tarifa Stone + 160% de lucro' },
        { value: 'stone+170', text: 'Tarifa Stone + 170% de lucro' },
        { value: 'stone+180', text: 'Tarifa Stone + 180% de lucro' },
        { value: 'stone+190', text: 'Tarifa Stone + 190% de lucro' },
        { value: 'stone+200', text: 'Tarifa Stone + 200% de lucro' },
      ]
    }
  },
  async created () {
    await this.getData(this.$route.params.id)
  },
  methods: {
    async save () {
      let url = process.env.VUE_APP_URL_APP + `/b/admin/events/${this.$route.params.id}/payment-methods`
      try {
        let pm = this.modifyProperties(this.form.payment_methods, ['percentage_rate', 'percentage_rate_acquirer', 'fixed_rate', 'fixed_rate_acquirer'], 'multiply')
        let payload = {
          payment_methods: pm
        }
        let resp = await this.$http.patch(url, payload)
        if (resp.ok) {
          this.f = {
            msg: 'Salvo com sucesso',
            show: true,
            variant: 'success'
          }
          this.form_initial_state = this.$_.cloneDeep(this.form)
        }
      } catch (e) {
        this.f = {
          msg: e.body.message,
          show: true,
          variant: 'danger'
        }
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    toggleEnabled (idx) {
      this.form.payment_methods[idx].enabled = !this.form.payment_methods[idx].enabled
    },
    async getData (eventId) {
      let url = process.env.VUE_APP_URL_APP + `/b/admin/events/${eventId}/payment-methods`
      try {
        let resp = await this.$http.get(url)
        this.form = resp.body
        this.form.payment_methods = this.modifyProperties(this.form.payment_methods, ['percentage_rate', 'percentage_rate_acquirer', 'fixed_rate', 'fixed_rate_acquirer'], 'divide')

        this.form_initial_state = this.$_.cloneDeep(this.form)
      } catch (e) {
        console.error(e)
      }
      return false
    },
    applyRateLayout () {
      for (let i = 0; i < this.form.payment_methods.length; i++) {
        switch (this.form.payment_methods[i].method) {
          case 'pix':
            this.form.payment_methods[i].percentage_rate_acquirer = 0.5
            this.form.payment_methods[i].percentage_rate = 0.5 * ((this.ratioFromRateLayout / 100) + 1)
            break;
          case 'debito':
            this.form.payment_methods[i].percentage_rate_acquirer = 0.99
            this.form.payment_methods[i].percentage_rate = 0.99 * ((this.ratioFromRateLayout / 100) + 1)
            break;
          case 'cred_a_vista':
            this.form.payment_methods[i].percentage_rate_acquirer = 1.95
            this.form.payment_methods[i].percentage_rate = 1.95 * ((this.ratioFromRateLayout / 100) + 1)
            break;
          case 'cred_parc_2':
          case 'cred_parc_3':
          case 'cred_parc_4':
          case 'cred_parc_5':
          case 'cred_parc_6':
            this.form.payment_methods[i].percentage_rate_acquirer = 2.73
            this.form.payment_methods[i].percentage_rate = 2.73 * ((this.ratioFromRateLayout / 100) + 1)
            break;
          case 'cred_parc_7':
          case 'cred_parc_8':
          case 'cred_parc_9':
          case 'cred_parc_10':
          case 'cred_parc_11':
          case 'cred_parc_12':
            this.form.payment_methods[i].percentage_rate_acquirer = 3
            this.form.payment_methods[i].percentage_rate = 3 * ((this.ratioFromRateLayout / 100) + 1)
            break;

          default:
            break;
        }
      }
    },
    modifyProperties(arr, propertyNames, operationName) {
      if (operationName !== 'multiply' && operationName !== 'divide') {
        console.error('Invalid operation name. Use "multiply" or "divide".');
        return [];
      }

      return arr.map(obj => {
        const newObj = { ...obj };
        propertyNames.forEach(propertyName => {
          if (typeof newObj[propertyName] === 'number') {
            newObj[propertyName] = operationName === 'multiply'
              ? newObj[propertyName] * 100
              : newObj[propertyName] / 100;
          }
        });
        return newObj;
      });
    },
  },
  computed: {
    disableSaveBtn () {
      return this.$_.isEqual(this.form, this.form_initial_state)
    },
    ratioFromRateLayout () {
      let parts = this.rate_layout.split("+")

      if (parts.length === 2) {
        var numberString = parts[1]
        return parseInt(numberString, 10)
      }
      return 0
    },
    calculateProfit () {
      return this.form.payment_methods.map(function (item) {
        let fixedProfit = item.fixed_rate - item.fixed_rate_acquirer
        fixedProfit = fixedProfit.toFixed(2)
        let percentageProfit = item.percentage_rate - item.percentage_rate_acquirer
        percentageProfit = percentageProfit.toFixed(2)
        return { fixedProfit: fixedProfit * 100, percentageProfit: percentageProfit * 100 }
      })
    }
  }
}
</script>

<style>
.bg-easy {
  background-color: rgb(241, 249, 255);
}
.bg-stone{
  background-color: rgb(241, 255, 243);
}
</style>
